const STORAGE_KEY = 'versa_consent';
const CLARITY_ID = 'wn0kxj2wzq';

// Bump when categories or disclosures change to re-prompt all users.
export const CONSENT_VERSION = 1;

const DEFAULTS = {
  v: CONSENT_VERSION,
  necessary: true,
  analytics: false,
  marketing: false,
  ts: 0,
};

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && parsed.v === CONSENT_VERSION) return parsed;
    return null;
  } catch {
    return null;
  }
}

export function hasDecision() {
  return getConsent() !== null;
}

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function loadClarity() {
  if (window.__clarityLoaded) return;
  window.__clarityLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.clarity.ms/tag/' + CLARITY_ID;
  const first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(s, first);
}

function applyToGoogle(state) {
  const analytics = state.analytics ? 'granted' : 'denied';
  const marketing = state.marketing ? 'granted' : 'denied';
  gtag('consent', 'update', {
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
    analytics_storage: analytics,
  });
  if (state.analytics) loadClarity();
}

export function setConsent(partial) {
  const next = {
    ...DEFAULTS,
    ...partial,
    v: CONSENT_VERSION,
    necessary: true,
    ts: Date.now(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {}
  applyToGoogle(next);
  return next;
}

export function applyStoredConsentOnLoad() {
  const stored = getConsent();
  if (stored) applyToGoogle(stored);
}

const OPEN_EVENT = 'versa:consent-open';

export function openPreferences() {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export function onOpenPreferences(handler) {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
}
